export enum AppThresholds {
  AppSPIScreenLoadThreshold = 'spi_screen_load_threshold',
  AppSPIPageLoadThreshold = 'spi_page_load_threshold',
  AppSPIMobileStartupTimeThreshold = 'spi_mobile_app_startup_time_threshold',
  AppSPIAppCrashThreshold = 'spi_app_crash_threshold',
  AppSPIBadEventsThreshold = 'spi_bad_events_threshold',
  AppSPIANRThreshold = 'spi_anr_threshold',
}

export const APP_CREATE_NEW_SPI_CONFIG = {
  [AppThresholds.AppSPIScreenLoadThreshold]: 5,
  [AppThresholds.AppSPIPageLoadThreshold]: 5,
  [AppThresholds.AppSPIMobileStartupTimeThreshold]: 5,
  [AppThresholds.AppSPIAppCrashThreshold]: 1,
  [AppThresholds.AppSPIBadEventsThreshold]: 0,
};

export const APP_DEFAULT_KPI_CONFIG = {
  [AppThresholds.AppSPIScreenLoadThreshold]: 5,
  [AppThresholds.AppSPIPageLoadThreshold]: 5,
  [AppThresholds.AppSPIMobileStartupTimeThreshold]: 5,
  [AppThresholds.AppSPIAppCrashThreshold]: 1,
  [AppThresholds.AppSPIBadEventsThreshold]: 0,
  kpiName: 'Conviva Good',
  kpiID: 5,
};
